
import React from 'react';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://imgs1.cdn-imobibrasil.com.br/imagens/imoveis/202508121421232457.jpeg)",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Navigation - Fixed */}
        <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm transition-all duration-300">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="text-white">
                <h1
                  className="text-xl font-bold"
                  style={{ fontFamily: '"Pacifico", serif' }}
                >
                  Edifício Amálio
                </h1>
                <p className="text-xs opacity-90">MV Imóveis</p>
              </div>
              <div className="hidden md:flex space-x-6">
                <a
                  href="#apartamentos"
                  className="text-white hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
                >
                  Apartamentos
                </a>
                <a
                  href="#diferenciais"
                  className="text-white hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
                >
                  Diferenciais
                </a>
                <a
                  href="#condicoes"
                  className="text-white hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
                >
                  Condições
                </a>
                <a
                  href="#contato"
                  className="text-white hover:text-gray-300 transition-colors cursor-pointer whitespace-nowrap text-sm font-medium"
                >
                  Contato
                </a>
              </div>
              <button className="md:hidden text-white text-xl cursor-pointer">
                <i className="ri-menu-line"></i>
              </button>
            </div>
          </div>
        </nav>

        {/* Hero Content */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center text-white pt-20">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
              Apartamento dos Sonhos
              <span className="block text-gray-300">no Edifício Amálio</span>
            </h1>
            <p className="text-xl md:text-2xl mb-8 opacity-90 leading-relaxed">
              Chegou a sua chance de conquistar o apartamento dos sonhos no Alto da
              XV
              <span className="block font-semibold text-gray-200">
                em Guarapuava/PR
              </span>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="https://chat.whatsapp.com/GrKUvQCDm3MIv7vGmmuCK2"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-600 hover:bg-green-7 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Receba Apresentação no WhatsApp
              </a>
              <a
                href="#contato"
                className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Fale com MV Imóveis
              </a>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </section>

      {/* Apartamentos Section */}
      <section id="apartamentos" className="py-20 bg-gray-50 pt-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Escolha Seu Apartamento Ideal
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              No Edifício Amálio você tem opções que se adaptam ao seu estilo de vida
              e necessidades
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-home-4-line text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Apartamentos Modernos
              </h3>
              <p className="text-gray-600 mb-4">
                Apartamentos compactos e funcionais, perfeitos para quem busca
                praticidade e modernidade
              </p>
              <div className="text-3xl font-bold text-gray-700 mb-2">
                A partir de 40m²
              </div>
              <div className="text-sm text-gray-500">
                Ideais para jovens profissionais
              </div>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-building-4-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Apartamentos Amplos
              </h3>
              <p className="text-gray-600 mb-4">
                Espaços generosos com 3 quartos, suíte, sala espaçosa e varanda com
                churrasqueira
              </p>
              <div className="text-3xl font-bold text-gray-700 mb-2">
                Até 82m²
              </div>
              <div className="text-sm text-gray-500">
                Perfeitos para famílias
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-white">
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-6">
                Características dos Apartamentos
              </h3>
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-hotel-bed-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">3 Quartos com Suíte</h4>
                  <p className="text-sm opacity-90">
                    Dormitórios amplos e confortáveis
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-sofa-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Sala Espaçosa</h4>
                  <p className="text-sm opacity-90">
                    Ambiente integrado para toda família
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-restaurant-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Varanda com Churrasqueira</h4>
                  <p className="text-sm opacity-90">
                    Espaço gourmet para momentos especiais
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais Section */}
      <section id="diferenciais" className="py-20 bg-white pt-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Diferenciais que Realmente Fazem a Diferença
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              O Edifício Amálio oferece comodidades modernas que transformam seu dia a
              dia
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img
                alt="Edifício Amálio - Fachada com Elevador Moderno"
                className="w-full h-96 object-cover rounded-xl shadow-lg"
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/fcdb316bc978a26e29d3ca5a704c36ac.jfif"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Conforto e Sustentabilidade
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-arrow-up-down-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Elevador Moderno
                    </h4>
                    <p className="text-gray-600">
                      Conforto e acessibilidade para todos os moradores, facilitando o
                      acesso a todos os andares
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-sun-line text-yellow-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Energia Solar
                    </h4>
                    <p className="text-gray-600">
                      Sistema sustentável que gera economia na conta de luz e contribui para
                      o meio ambiente
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-map-pin-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Localização Privilegiada
                    </h4>
                    <p className="text-gray-600">
                      Alto da XV, tavessia Dr Muricy 157, uma das melhores regiões de Guarapuava/PR
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Vista Aérea do Empreendimento
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-building-2-line text-purple-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Projeto Arquitetônico Moderno
                    </h4>
                    <p className="text-gray-600">
                      Design contemporâneo que se destaca na paisagem urbana de Guarapuava
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-car-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Estacionamento Amplo
                    </h4>
                    <p className="text-gray-600">
                      Vagas cobertas para garantir comodidade aos moradores
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-tree-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Área Verde Preservada
                    </h4>
                    <p className="text-gray-600">
                      Paisagismo planejado com áreas verdes que proporcionam qualidade de vida
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                alt="Edifício Amálio - Vista Aérea do Empreendimento"
                className="w-full h-96 object-cover rounded-xl shadow-lg"
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/8c24aea3a5eeb242bc104879eec86475.jfif"
              />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img
                alt="Edifício Amálio - Interior do Apartamento com Acabamentos Modernos"
                className="w-full h-96 object-cover rounded-xl shadow-lg"
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/d7e5ec07e4bd2349331a2f29352f7b59.png"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Acabamentos de Médio Padrão
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-home-heart-line text-blue-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Ambientes Integrados
                    </h4>
                    <p className="text-gray-600">
                      Sala e cozinha integradas com design moderno, criando um ambiente amplo e funcional para o dia a dia
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Área Gourmet
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-restaurant-line text-red-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Sacada com Churrasqueira
                    </h4>
                    <p className="text-gray-600">
                      Espaço gourmet completo na varanda, perfeito para receber amigos e família com todo conforto
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-cup-line text-orange-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Bancada Gourmet
                    </h4>
                    <p className="text-gray-600">
                      Bancada em granito com espaço para preparo de alimentos e apoio para churrascos
                    </p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-windy-line text-green-600 text-xl"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 text-lg mb-2">
                      Ventilação Natural
                    </h4>
                    <p className="text-gray-600">
                      Varanda ampla com excelente ventilação, proporcionando conforto em todos os momentos
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                alt="Edifício Amálio - Área Gourmet com Churrasqueira na Varanda"
                className="w-full h-96 object-cover rounded-xl shadow-lg"
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/e67ca081ad7d45cf8a8cf9b85e98c9e7.jfif"
              />
            </div>
          </div>

          <div className="bg-gradient-to-r from-gray-700 to-gray-600 rounded-2xl p-8 md:p-12 text-white">
            <div className="text-center">
              <h3 className="text-3xl font-bold mb-6">
                Por que escolher o Edifício Amálio?
              </h3>
              <div className="grid md:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-map-pin-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Localização Premium</h4>
                  <p className="text-sm opacity-90">Alto da XV, Guarapuava/PR</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-building-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Qualidade Construtiva</h4>
                  <p className="text-sm opacity-90">Padrão MV Imóveis de excelência</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-heart-2-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Sustentabilidade</h4>
                  <p className="text-sm opacity-90">Materiais eco‑friendly e energia solar</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-4 mb-4">
                    <i className="ri-shield-check-line text-2xl text-white"></i>
                  </div>
                  <h4 className="font-bold mb-2">Segurança 24h</h4>
                  <p className="text-sm opacity-90">Monitoramento constante e controle de acesso</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Condições Section */}
      <section id="condicoes" className="py-20 bg-gray-900 text-white pt-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Condições Imperdíveis
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Facilitamos a realização do seu sonho com condições especiais de
              pagamento
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            <div className="bg-gradient-to-b from-green-600 to-green-7 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Valores Acessíveis</h3>
              <div className="text-2xl font-bold mb-2">A partir de</div>
              <div className="text-3xl font-bold">R$ 399 mil</div>
            </div>

            <div className="bg-gradient-to-b from-blue-600 to-blue-7 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-percent-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Entrada Facilitada</h3>
              <div className="text-2xl font-bold mb-2">Entre</div>
              <div className="text-3xl font-bold">10% e 30%</div>
            </div>

            <div className="bg-gradient-to-b from-purple-600 to-purple-7 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-car-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Aceita Veículo</h3>
              <div className="text-lg mb-2">Carro ou imóvel</div>
              <div className="text-xl font-bold">como pagamento</div>
            </div>

            <div className="bg-gradient-to-b from-orange-600 to-orange-7 p-8 rounded-xl text-center">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-wallet-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold mb-2">Verba Ajustável</h3>
              <div className="text-lg mb-2">Condições que</div>
              <div className="text-xl font-bold">cabem no seu orçamento</div>
            </div>
          </div>
        </div>
      </section>

      {/* Contato Section */}
      <section id="contato" className="py-20 bg-gray-900 text-white pt-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Não Perca Tempo!
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Receba toda a apresentação com imagens direto no seu WhatsApp e garante o
              seu apartamento no Edifício Amálio
            </p>
          </div>

          <div className="text-center">
            <a
              href="https://chat.whatsapp.com/GrKUvQCDm3MIv7vGmmuCK2"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-7 text-white px-12 py-6 rounded-lg font-bold text-xl transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-3"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              Receber Apresentação no WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          {/* Aviso Legal */}
          <div className="bg-gray-800 rounded-lg p-6 mb-8">
            <div className="flex items-start space-x-3">
              <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-information-line text-white text-sm"></i>
              </div>
              <div>
                <h4 className="font-semibold text-yellow-400 mb-2">Aviso Importante</h4>
                <p className="text-sm text-gray-300 leading-relaxed">
                  <strong>Todas as fotos são ilustrativas.</strong> As informações apresentadas neste site precisam ser confirmadas através da imobiliária MV Imóveis e dos corretores credenciados. 
                  Itens como área gourmet, churrasqueira e outros acabamentos serão entregues <strong>preparados pela construtora</strong> (com pontos de instalação), 
                  mas não necessariamente prontos e finalizados. Bancadas, móveis planejados e alguns acabamentos podem não estar inclusos na entrega. 
                  Consulte sempre as especificações técnicas e memorial descritivo oficial do empreendimento para informações precisas sobre o que está incluso.
                </p>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <p className="text-sm opacity-80">
              © {new Date().getFullYear()} MV Imóveis. Todos os direitos reservados.{' '}
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-gray-300 transition-colors"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
